export default {
  path: '/lyn-test',
  name: 'lyn-test',
  component: () => import(`@/page/lyn-test/index.vue`),
  meta: {
    skip_check_token: true,
  },
};
